// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchChimps_wrapper__3tnhz","input":"SearchChimps_input__3FjS1","icon":"SearchChimps_icon__OhJf_"};